import { Modal, Form, Input, Select, Tag } from 'antd';
import { authFetch } from '../../../../../common/request/authFetch';
import { useTranslation } from 'react-i18next';
import { DrawerPanelTitle, modalPanelStyles } from '../../../common/Drawers/DrawerPanelTitle';

export const EditLocationEmailsModal = (props : {locationReportConfig: any, onFinish: any}) => {
    
    const [form] = Form.useForm();
    //debugger;
	const { t } = useTranslation();    
    
    const onFormFinish = async (values: any) => {
        const data = {
            ...values
        };
        await authFetch(`${process.env.REACT_APP_API}/projects/${props.locationReportConfig.project}/reports/${props.locationReportConfig.groupAccount}/${props.locationReportConfig.locationId}/emails`, { method: 'PUT', data: data });        
        props.onFinish();
    };

  return (
    <>
        <Modal 
            open={true} 
            onOk={() => form.submit()} 
            onCancel={props.onFinish} 
            afterClose={form.resetFields}
            {...modalPanelStyles}
            okText='Guardar'
            cancelText='Cancelar'
            destroyOnClose
            title={<DrawerPanelTitle title="Gestionar destinatarios" />}
        >
            <Form 
                layout='vertical' 
                form={form} 
                onFinish={onFormFinish}
                autoComplete="off"
                initialValues={{ emails: props.locationReportConfig.emails }} 
            >                
                <Form.Item 
                    label='Correos' 
                    name='emails'
                    rules={[
                        {
                            validator: async (_, emails: string[]) => {
                                if (emails) {
                                    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                                    const invalidEmails = emails.filter(email => !emailRegex.test(email));
                                    if (invalidEmails.length > 0) {
                                        return Promise.reject(new Error('Hay correos con formato inválido'));
                                    }
                                }
                                return Promise.resolve();
                            },
                        },
                    ]}
                >
                    <Select 
                        mode="tags" 
                        style={{ width: '100%' }} 
                        placeholder="Escribe un email y pulsa Enter"
                        tokenSeparators={[',', ' ']} 
                        notFoundContent={null} 
                    >
                        
                    </Select>
                </Form.Item>    
            </Form>
        </Modal>
    </>
  )
}

